
export const getPlanIdByName = {
  "Group monthly": process.env.REACT_APP_PRODUCT_MONTHLY_GROUP_PLAN_ID,
  "Group Yearly": process.env.REACT_APP_PRODUCT_YEARLY_GROUP_PLAN_ID,
  monthly: process.env.REACT_APP_PRODUCT_MONTHLY_PLAN_ID,
  yearly: process.env.REACT_APP_PRODUCT_YEARLY_PLAN_ID,
};
